import { useEffect } from 'react';
import { materialize } from '../services/recurringService';
import { todayStr } from '@/shared/utils/dateHelpers';
import { reportToSentry } from '@/lib/sentry';

// Dedupe (sourceBillId + date) and lastGeneratedDate make re-runs a no-op,
// so the effect is safe to fire on every data change rather than once per session.
// That way a bill added in-session auto-generates without a reload.
export function useBillRecurrence({ data, save, defaultPayment, resolvedUserName, toast }) {
  useEffect(() => {
    if (!data) return;

    const bills = data.bills || [];
    const txns = data.txns || [];
    if (bills.length === 0) return;

    const result = materialize(bills, txns, {
      today: todayStr(),
      defaultPayment,
      resolvedUserName,
    });

    if (result.newTxns.length === 0) return;

    const updatedBills = bills.map(b =>
      result.billUpdates.has(b.id)
        ? { ...b, lastGeneratedDate: result.billUpdates.get(b.id) }
        : b
    );

    const next = {
      ...data,
      txns: [...result.newTxns, ...txns],
      bills: updatedBills,
    };

    save(next).then(() => {
      if (toast) toast.success('Generated ' + result.newTxns.length + ' transaction' + (result.newTxns.length === 1 ? '' : 's') + ' from bills');
    }).catch((e) => {
      console.error('[useBillRecurrence] save failed', e);
      reportToSentry(e, { op: 'billRecurrence.save', newTxnCount: result.newTxns.length });
    });
  }, [data, save, defaultPayment, resolvedUserName, toast]);
}
